// extracted by mini-css-extract-plugin
export default {"wrapper":"Disclaimer_wrapper__BSNHK"};